import { FormControl, InputLabel, Select } from '@mui/material'
import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'
import { Controller } from 'react-hook-form'

// Helper component for adding material UI select components to a react hook form
//
// Example usage:
// <SelectField id="type" name="type" label="Type" control={control}>
//   <MenuItem value="test">Test</MenuItem>
// </SelectField>
//
// where MenuItem is imported from @mui/material

interface Props<T extends object> {
  name: string
  id: string
  label: string
  control: UseFormReturn<T>['control']
  children: ReactNode
  describedBy?: string
}

const MuiSelectField = <T extends object>({
  label,
  name,
  id,
  control,
  children,
  describedBy,
}: Props<T>) => (
  <FormControl fullWidth>
    <InputLabel id={id}>{label}</InputLabel>
    <Controller<T>
      render={({ field: { onChange, value } }) => (
        <Select
          fullWidth
          labelId={id}
          id={id}
          name={name}
          value={value}
          label={label}
          onChange={onChange}
          SelectDisplayProps={{ 'aria-describedby': describedBy }}
        >
          {children}
        </Select>
      )}
      control={control}
      name={name as any}
    />
  </FormControl>
)

export default MuiSelectField
